import React from "react";
import Cover from "../../components/cover/cover";
import ViewPitch from "../../components/viewcourt/viewcourt";
import Navigation, { getContainerClass } from "../../components/navigation/navigation";
import { useLocation } from "react-router-dom";
// import Header from "../../components/header/header";
const PitchCourtPage = () => {
  const breadcrumb = ["Home", "Facilities", "Pitch Court"];
  const location = useLocation();
  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="court" />
        <div className="">
          <ViewPitch />
        </div>
      </div>
    </>
  );
};

export default PitchCourtPage;
